import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {ItemBorderObject} from '@PosterWhiteboard/classes/item-border.class';

export function useGetKeyFromBorderOfActiveItem<T extends keyof ItemBorderObject>(key: T): ItemBorderObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'border' in item && item.border[key] !== undefined) {
      return item.border[key];
    }

    return undefined;
  });
}
